// extracted by mini-css-extract-plugin
module.exports = {"above-small":"851px","card":"Card-module__card___32-Ho"};